import { EntityType, trackerApi } from '@texas/api/endpoints/trackerApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { createContext, useCallback, useEffect } from 'react';
import { trackerEvents } from './events';
import { compareEnum } from '@texas/utils/helpers/enumHelpers';
import { useSignalSubscriptionEvents } from '../hooks/useSignalSubscriptionEvents';

export function useTracker() {
  const { data, refetch } = useApiResource(trackerApi.summary);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useSignalSubscriptionEvents({
    triggerOnEvent: () => {
      refetch();
    },
    signalEvents: [trackerEvents.onAdded, trackerEvents.onRemoved],
  });

  const hasWatcher = useCallback(
    (id: number, entityType: EntityType) => {
      if (!data) return false;
      return data.watchers.some(
        (d) =>
          d.entityId === id &&
          compareEnum(EntityType, d.entityType, entityType),
      );
    },
    [data],
  );

  return { trackers: data, hasWatcher };
}

export const TrackerContext = createContext<ReturnType<
  typeof useTracker
> | null>(null);
